import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type SetAllSelectedAction = {
  type: ActionType.SetAllSelected;
  selected: boolean;
}


/**
 * Dispatch this set the selected status for all reports.
 * @param selected - the new selected state you want (default: false)
 */
export const setAllSelectedAction = (selected: boolean): SetAllSelectedAction => ({
  type:     ActionType.SetAllSelected,
  selected: selected,
});


export const setAllSelectedReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SetAllSelected) {
    return state;
  }
  
  const action = incomingAction as SetAllSelectedAction;

  const reports = state.reportRecipientReports || [];
  const updatedReports = Object.values(reports).reduce(
    (map, r) => R.assoc(`${r.participantReportId}`, R.mergeRight(r, { isChecked: action.selected }), map),
    {},
  );

  return R.assoc('reportRecipientReports', Object.values(updatedReports), state);
};
